import React from 'react';
import { Breadcrumb, Panel } from 'rsuite';
import PageHeader from '@/components/PageHeader';
import PointTypeList from './point-type-list';

const Page = () => {
  return (
    <Panel
      header={
        <PageHeader title="Point Types">
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item active>Point Types</Breadcrumb.Item>
          </Breadcrumb>
        </PageHeader>
      }
    >
      <PointTypeList />
    </Panel>
  );
};

export default Page;
